import { render } from "./Specialties.vue?vue&type=template&id=1c1b04fa&scoped=true&ts=true"
import script from "./Specialties.vue?vue&type=script&lang=ts"
export * from "./Specialties.vue?vue&type=script&lang=ts"

import "./Specialties.vue?vue&type=style&index=0&id=1c1b04fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1b04fa"]])

export default __exports__